/**
 * Normalize Vista CHAR-style codes for comparison (trim, ignore trailing dots, case).
 */
export function normalizeCanonicalListValue(id: string): string {
    return id.trim().replace(/\.+$/g, '').toLowerCase()
}

/**
 * Returns the exact stored list value that matches `stored` loosely, or `null` if unknown.
 * Use so `[(ngModel)]` matches Wijmo combo `[selectedValuePath]="'value'"` when one side is trimmed.
 */
export function resolveCanonicalListValue(stored: string | undefined | null, values: Array<string | null | undefined>): string | null {
    if (stored == null) return null
    const raw = String(stored).trim()
    if (!raw) return null
    const want = normalizeCanonicalListValue(raw)
    for (const value of values) {
        if (value == null || value === '') continue
        if (normalizeCanonicalListValue(value) === want) {
            return value
        }
    }
    return null
}
